/* ===========================================================================
   BKR — theme behaviour
   Vanilla. No framework, no jQuery, no vendored library.
   Every cart mutation goes through Shopify's AJAX Cart API and re-renders the
   affected sections through the Section Rendering API, so markup stays in Liquid.
   ======================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cfg = window.BKR || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     Overlays: bag drawer, mobile menu, search
     ------------------------------------------------------------------ */
  var lastFocus = null;

  function openOverlay(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    var scrim = $('#scrim');
    if (scrim) scrim.hidden = false;
    el.hidden = false;
    requestAnimationFrame(function () {
      if (scrim) scrim.classList.add('is-show');
      el.classList.add('is-show');
      var first = el.querySelector('input, button, a[href]');
      if (first) first.focus({ preventScroll: true });
    });
    document.body.classList.add('is-locked');
    document.addEventListener('keydown', trapKeys);
  }

  function closeOverlays() {
    ['#cart-drawer', '#mobile-menu', '#search-panel'].forEach(function (sel) {
      var el = $(sel);
      if (!el || !el.classList.contains('is-show')) return;
      el.classList.remove('is-show');
      window.setTimeout(function () { el.hidden = true; }, 520);
    });
    var scrim = $('#scrim');
    if (scrim) {
      scrim.classList.remove('is-show');
      window.setTimeout(function () { scrim.hidden = true; }, 420);
    }
    document.body.classList.remove('is-locked');
    document.removeEventListener('keydown', trapKeys);
    var burger = $('#burger');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function trapKeys(e) {
    if (e.key === 'Escape') { closeOverlays(); return; }
    if (e.key !== 'Tab') return;
    var open = $('.drawer.is-show, .mnav.is-show, .searchpanel.is-show');
    if (!open) return;
    var f = $$('a[href], button:not([disabled]), input, textarea, select', open)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------------------------------------------------------------
     Toast
     ------------------------------------------------------------------ */
  var toastTimer;
  function toast(head, sub) {
    var t = $('#toast');
    if (!t) return;
    t.innerHTML = '<b></b>' + (sub ? '<span></span>' : '');
    t.querySelector('b').textContent = head;
    if (sub) t.querySelector('span').textContent = sub;
    t.classList.add('is-show');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { t.classList.remove('is-show'); }, 3200);
  }

  /* ---------------------------------------------------------------------
     Cart
     ------------------------------------------------------------------ */
  function sectionsToRender() {
    var ids = ['cart-drawer'];
    if (document.getElementById('shopify-section-main-cart')) ids.push('main-cart');
    return ids;
  }

  /* The header is deliberately NOT re-rendered — it holds scroll state.
     Its counter is updated straight from the cart JSON instead. */
  function paintCount() {
    return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      })
      .catch(function () { /* count is cosmetic — never block the cart on it */ });
  }

  function applySections(data) {
    /* The drawer re-renders from Liquid, which would otherwise snap it shut
       mid-edit. Remember whether it was open and put it back. */
    var drawer = $('#cart-drawer');
    var wasOpen = !!(drawer && drawer.classList.contains('is-show'));

    if (data && data.sections) {
      Object.keys(data.sections).forEach(function (id) {
        var host = document.getElementById('shopify-section-' + id);
        if (!host) return;
        var parsed = new DOMParser().parseFromString(data.sections[id], 'text/html');
        var fresh = parsed.getElementById('shopify-section-' + id);
        if (fresh) host.innerHTML = fresh.innerHTML;
      });
    }

    if (wasOpen) {
      var next = $('#cart-drawer');
      if (next) { next.hidden = false; next.classList.add('is-show'); }
    }
    bindCartControls();
    paintCount();
  }

  function cartRequest(url, body, onDone) {
    body.sections = sectionsToRender();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || cfg.strings.error);
        if (onDone) onDone(res.json);
        return res.json;
      })
      .catch(function (err) { toast(cfg.strings.error, err.message); throw err; });
  }

  function addToCart(id, qty, btn, props) {
    if (btn) btn.classList.add('is-loading');
    var line = { id: Number(id), quantity: Number(qty) || 1 };
    if (props && Object.keys(props).length) line.properties = props;
    return cartRequest(cfg.routes.cart_add, { items: [line] })
      .then(function (json) {
        var item = (json.items && json.items[0]) || json;
        return fetchCartSections().then(function () {
          toast(cfg.strings.added, item.product_title || '');
          if (cfg.cartType === 'drawer') openOverlay($('#cart-drawer'));
          else window.location.href = cfg.routes.cart;
        });
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function fetchCartSections() {
    var ids = sectionsToRender().join(',');
    return fetch('?sections=' + encodeURIComponent(ids))
      .then(function (r) { return r.json(); })
      .then(function (sections) { applySections({ sections: sections }); });
  }

  function changeLine(key, qty) {
    return cartRequest(cfg.routes.cart_change, { id: key, quantity: Number(qty) }, applySections);
  }

  function bindCartControls() {
    $$('[data-line-qty]').forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = '1';
      input.addEventListener('change', function () {
        changeLine(input.dataset.lineKey, input.value);
      });
    });
    var noteEl = $('#cart-note');
    if (noteEl && !noteEl.dataset.bound) {
      noteEl.dataset.bound = '1';
      var noteTimer;
      noteEl.addEventListener('input', function () {
        window.clearTimeout(noteTimer);
        noteTimer = window.setTimeout(function () {
          fetch(cfg.routes.cart_update, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteEl.value })
          });
        }, 500);
      });
    }
  }

  /* ---------------------------------------------------------------------
     Product page
     ------------------------------------------------------------------ */
  function bindProduct() {
    var form = $('#product-form');
    if (!form) return;

    var qtyInput = $('#qty-input', form);
    $$('[data-qty-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var step = Number(b.dataset.qtyStep);
        var next = Math.max(1, (Number(qtyInput.value) || 1) + step);
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Flavour choices ride along as line-item properties. A select left on
       its placeholder is a real mistake — the baker would have to guess — so
       it blocks the add rather than defaulting to something. */
    function readChoices() {
      var props = {};
      var missing = null;
      $$('[data-prop]', form).forEach(function (el) {
        var key = el.dataset.prop;
        var row = el.closest('.choice');
        if (el.type === 'checkbox') {
          if (el.checked) props[key] = el.value;
          return;
        }
        if (!el.value) {
          if (!missing) missing = el;
          if (row) row.classList.add('choice--bad');
          return;
        }
        if (row) row.classList.remove('choice--bad');
        props[key] = el.value;
      });
      return { props: props, missing: missing };
    }

    $$('select[data-prop]', form).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var row = sel.closest('.choice');
        if (row && sel.value) row.classList.remove('choice--bad');
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var picked = readChoices();
      if (picked.missing) {
        toast(cfg.strings.chooseFirst, picked.missing.dataset.prop);
        picked.missing.focus();
        return;
      }
      var id = form.querySelector('[name="id"]').value;
      addToCart(id, qtyInput ? qtyInput.value : 1, form.querySelector('[type="submit"]'), picked.props);
    });

    /* Variant picking. Options are read off the buttons so Liquid stays the
       source of truth for what exists. Bake days are the same mechanism with
       one option, plus the cutoff state. */
    var data = $('#variant-data');
    if (data) {
      var variants = JSON.parse(data.textContent);
      var chosen = [];
      $$('[data-opt-index]').forEach(function (group) {
        var idx = Number(group.dataset.optIndex);
        var on = group.querySelector('[aria-checked="true"]');
        chosen[idx] = on ? on.dataset.value : null;
        group.addEventListener('click', function (e) {
          var b = e.target.closest('.swatch, .bake');
          if (!b || b.disabled) return;
          $$('.swatch, .bake', group).forEach(function (s) {
            s.setAttribute('aria-checked', String(s === b));
          });
          chosen[idx] = b.dataset.value;
          selectVariant(variants, chosen, form);
        });
      });
    }

    /* Gallery */
    var thumbs = $('#pdp-thumbs');
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var main = $('#pdp-main-img');
        main.src = b.dataset.src;
        if (b.dataset.srcset) main.srcset = b.dataset.srcset;
        main.alt = b.dataset.alt || '';
        $$('button', thumbs).forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
      });
    }

    /* Sticky add-to-bag on phones, once the real button scrolls away */
    var sticky = $('#pdp-sticky');
    var addBtn = form.querySelector('[type="submit"]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-up', !entries[0].isIntersecting);
      }, { rootMargin: '-90px 0px 0px 0px' }).observe(addBtn);
      sticky.querySelector('button').addEventListener('click', function () {
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* Server clock at render time, so a viewer whose device clock is wrong does
     not get a cutoff decided by their laptop. Advanced locally from there. */
  var serverNow = (function () {
    var el = $('#bake-now');
    var s = el ? Number(el.textContent.trim()) : 0;
    var offset = s ? (s * 1000 - Date.now()) : 0;
    return function () { return Math.floor((Date.now() + offset) / 1000); };
  })();

  function selectVariant(variants, chosen, form) {
    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    var submit = form.querySelector('[type="submit"]');
    var btn = submit ? submit.querySelector('span') : null;
    var sticky = $('#pdp-sticky');
    var stickyBtn = sticky ? sticky.querySelector('span') : null;
    var priceEl = $('#pdp-price');
    var cutoffEl = $('#pdp-cutoff');
    var qtyBox = form.querySelector('.qty');
    var qtyInput = $('#qty-input', form);

    function setLabel(text) {
      if (btn) btn.textContent = text;
      if (stickyBtn) stickyBtn.textContent = text;
    }
    function setDisabled(state) {
      if (submit) submit.disabled = state;
      if (sticky) {
        var sb = sticky.querySelector('button');
        if (sb) sb.disabled = state;
      }
      if (qtyBox) qtyBox.hidden = state;
    }

    if (!match) {
      setLabel(cfg.strings.soldOut);
      setDisabled(true);
      return;
    }

    var closed = match.close > 0 && serverNow() >= match.close;
    var orderable = match.available && !closed;

    form.querySelector('[name="id"]').value = match.id;
    setDisabled(!orderable);
    setLabel(
      orderable ? cfg.strings.addToBag + ' — ' + match.price_formatted
                : (closed ? cfg.strings.bakeClosed : cfg.strings.soldOut)
    );

    if (priceEl) priceEl.innerHTML = match.price_html;

    /* Never let someone ask for more than that bake actually has. */
    if (qtyInput && match.qty > 0) {
      qtyInput.max = match.qty;
      if (Number(qtyInput.value) > match.qty) qtyInput.value = match.qty;
    }

    if (cutoffEl) {
      cutoffEl.dataset.close = match.close;
      if (orderable && match.close > 0) {
        cutoffEl.textContent = cfg.strings.bakeCloses + ' ' +
          new Date(match.close * 1000).toLocaleString(undefined, {
            weekday: 'short', day: 'numeric', month: 'short',
            hour: 'numeric', minute: '2-digit'
          });
      } else if (closed) {
        cutoffEl.textContent = cfg.strings.bakeClosedNote;
      } else {
        cutoffEl.textContent = cfg.strings.soldOut;
      }
    }

    /* The pickup window belongs to the bake day, not the store, so it moves
       with the selection. */
    var winEl = $('#pdp-window');
    if (winEl) {
      winEl.textContent = match.window || '';
      var winRow = winEl.closest('.pickup-win');
      if (winRow) winRow.hidden = !match.window;
    }

    if (match.featured_image && $('#pdp-main-img')) {
      $('#pdp-main-img').src = match.featured_image;
    }
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* A cutoff that lapses while the page is open should close the page, not
     wait for a reload. Checked once a minute; the real stop is inventory. */
  function watchCutoff() {
    var cutoffEl = $('#pdp-cutoff');
    var form = $('#product-form');
    if (!cutoffEl || !form) return;
    window.setInterval(function () {
      var close = Number(cutoffEl.dataset.close || 0);
      if (!close || serverNow() < close) return;
      var submit = form.querySelector('[type="submit"]');
      if (submit && !submit.disabled) {
        submit.disabled = true;
        var span = submit.querySelector('span');
        if (span) span.textContent = cfg.strings.bakeClosed;
        cutoffEl.textContent = cfg.strings.bakeClosedNote;
        var qtyBox = form.querySelector('.qty');
        if (qtyBox) qtyBox.hidden = true;
        toast(cfg.strings.bakeClosed, cfg.strings.bakeClosedNote);
      }
    }, 60000);
  }

  /* ---------------------------------------------------------------------
     Scroll motion
     ------------------------------------------------------------------ */
  var revealIO;
  function bindReveals() {
    if (revealIO) revealIO.disconnect();
    if (reduced || !cfg.motion || !cfg.motion.reveals || !('IntersectionObserver' in window)) {
      $$('.steps').forEach(function (s) { s.classList.add('is-in'); });
      return;
    }
    var vh = window.innerHeight;
    var targets = $$('[data-reveal], .steps').filter(function (el) {
      /* Anything already on screen at rest is never hidden. */
      if (el.getBoundingClientRect().top < vh - 60) {
        if (el.classList.contains('steps')) el.classList.add('is-in');
        return false;
      }
      el.classList.add('pre');
      return true;
    });
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        revealIO.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    targets.forEach(function (t) { revealIO.observe(t); });
  }

  var heroIO;
  function bindHeader() {
    var stack = $('#topstack');
    var hero = $('[data-hero]');
    if (!stack) return;
    if (heroIO) heroIO.disconnect();
    if (!hero || !('IntersectionObserver' in window)) { stack.classList.add('is-solid'); return; }
    stack.classList.remove('is-solid');
    heroIO = new IntersectionObserver(function (e) {
      stack.classList.toggle('is-solid', !e[0].isIntersecting);
    }, { rootMargin: '-72px 0px 0px 0px' });
    heroIO.observe(hero);
  }

  function bindMarquee() {
    if (!cfg.motion || !cfg.motion.marquee || reduced) return;
    $$('.marquee').forEach(function (m) { m.classList.add('marquee--anim'); });
  }

  /* ---------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------ */
  function bindSearch() {
    var input = $('#search-input');
    var out = $('#search-results');
    if (!input || !out || !cfg.routes.predictive) return;
    var t;
    input.addEventListener('input', function () {
      window.clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = window.setTimeout(function () {
        fetch(cfg.routes.predictive + '?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=4&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var res = doc.querySelector('#predictive-results');
            out.innerHTML = res ? res.innerHTML : '';
          })
          .catch(function () { out.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------------------------------------------------------------------
     Global delegation
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart(quick.dataset.quickAdd, 1, quick);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0); return; }

    var step = e.target.closest('[data-line-delta]');
    if (step) {
      e.preventDefault();
      var next = Math.max(0, Number(step.dataset.lineCurrent) + Number(step.dataset.lineDelta));
      changeLine(step.dataset.lineKey, next);
      return;
    }

    var openBag = e.target.closest('[data-open-bag]');
    if (openBag && cfg.cartType === 'drawer') { e.preventDefault(); openOverlay($('#cart-drawer')); return; }

    if (e.target.closest('[data-open-menu]'))   { $('#burger').setAttribute('aria-expanded', 'true'); openOverlay($('#mobile-menu')); return; }
    if (e.target.closest('[data-open-search]')) { openOverlay($('#search-panel')); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'scrim') { closeOverlays(); return; }
  });

  /* ---------------------------------------------------------------------
     Boot. Re-runs on Shopify customizer events so sections stay live.
     ------------------------------------------------------------------ */
  function boot() {
    bindHeader();
    bindReveals();
    bindMarquee();
    bindProduct();
    bindSearch();
    bindCartControls();
    watchCutoff();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  var rz;
  window.addEventListener('resize', function () {
    window.clearTimeout(rz);
    rz = window.setTimeout(bindReveals, 200);
  });

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('.drawer')) openOverlay($('#cart-drawer'));
  });

  window.BKRTheme = { addToCart: addToCart, openOverlay: openOverlay, closeOverlays: closeOverlays, toast: toast };
})();
